module.exports = "<button class=\"load-btn\" type=\"button\" (click)=\"loadBeat()\">Load</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/load-saved-beat/load-saved-beat.component.html
// module id = ../../../../../src/app/load-saved-beat/load-saved-beat.component.html
// module chunks = main